export const blockIconsUiactionsChevronLeftNew = (
	<span className='material-symbols-outlined'>chevron_left</span>
);
